/*
 * @Author: lidan
 * @Date: 2020-09-14 10:48:08
 * @LastEditTime: 2020-09-14 13:53:23
 * @LastEditors: Please set LastEditors
 * @Description: 部门管理api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\department.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_E6YUN_BASE_WEB = "" } = e6ModuleBaseDataApi;

//********************* 部门管理 ****************** */

//获取部门管理下拉树数据
export function findOrganizationTreeDepartment() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}

//保存部门
export function saveOrganization(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/saveOrganization`,
    method: "post",
    data
  });
}

//获取部门详情
export function getOrganizationDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/getOrganizationDetail`,
    method: "get",
    params
  });
}

//删除部门
export function deleteOrganization(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/deleteOrganization`,
    method: "get",
    params
  });
}

//检查部门编码唯一性
export function checkOnlyOrgCode(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/checkOnlyOrgCode`,
    method: "post",
    data
  });
}

//检查部门名称唯一性
export function checkOnlyOrgName(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/checkOnlyOrgName`,
    method: "post",
    data
  });
}
